export function createIdempotencyKey(): string {
  const randomUuid = globalThis.crypto?.randomUUID?.();
  if (randomUuid) return randomUuid;
  return `po-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export type PendingIdempotencyEntry = {
  scope: string;
  body: string;
  key: string;
};

export function getOrCreatePendingIdempotencyKey(
  registry: Record<string, PendingIdempotencyEntry>,
  scope: string,
  body: string,
): string {
  const existing = registry[scope];
  if (existing && existing.body === body) {
    return existing.key;
  }

  const next = {
    scope,
    body,
    key: createIdempotencyKey(),
  };
  registry[scope] = next;
  return next.key;
}

export function clearPendingIdempotencyKey(
  registry: Record<string, PendingIdempotencyEntry>,
  scope: string,
): void {
  delete registry[scope];
}
